import React from "react";
import "./Service_page.css";
import Free_Consultation from "../../home/free-consultation/Free_Consultation";
import { useNavigate } from "react-router-dom";
import { Services } from "../../../utils/apis/service/Service";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Service_page = () => {
  const navigate = useNavigate();

  const servicesData = [
    {
      id: 1,
      title: "Residential Rooftop Solar",
      description:
        "Save up to 90% on your electricity bills with government subsidy. We design and install customized rooftop solar systems for homes, ensuring maximum savings, safety, and long-term performance. From site survey to installation and subsidy support we handle everything. ",
      subtitle: "Best for: Individual homes, villas, apartments",
      image: "/assets/images/services/img-1.png",
    },
    {
      id: 2,
      title: "Commercial & Industrial Solar",
      description:
        "High-ROI solar solutions for businesses and industries. Reduce operational costs with reliable, scalable solar systems designed for factories, MSMEs, warehouses, and office buildings. Our systems ensure faster payback, high efficiency, and uninterrupted power.",
      subtitle: "Best for: Factories, MSMEs, corporate offices",
      image: "/assets/images/services/img-2.png",
    },
  ];

  const servicesData2 = [
    {
      id: 3,
      title: "Institutional & Society Solar",
      description:
        "Large-scale solar solutions for institutions & communities. We deliver solar projects for schools, hospitals, banks, housing societies, and government buildings with complete compliance, safety, and performance standards.",
      subtitle: "Best for: Schools, hospitals, societies, govt projects",
      image: "/assets/images/services/img-1.png",
    },
    {
      id: 4,
      title: "PM Surya Ghar – Subsidy Projects",
      description:
        "End-to-end subsidy and approval support. We manage the complete PM Surya Ghar process—application, DISCOM coordination, inspections, net-metering, and subsidy credit—so you enjoy a smooth, hassle-free solar experience.",
      subtitle: "Best for: Factories, MSMEs, corporate offices",
      image: "/assets/images/services/img-2.png",
    },
    {
      id: 5,
      title: "O&M (Operation & Maintenance)",
      description:
        "Keep your solar system performing at its best. Our O&M services ensure long-term efficiency through regular cleaning, preventive maintenance, real-time monitoring, and performance support. ",
      subtitle: "Best for: Schools, hospitals, societies, govt projects",
      image: "/assets/images/services/img-1.png",
    },
  ];

  const handleServiceClick = (id) => {
    navigate(`/services/${id}`);
  };

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [service, setService] = useState([]);

  const getService = async () => {
    const res = await Services();

    if (res?.success) {
      setService(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getService();
  }, []);

  const topServices = service.slice(0, 2);
  const bottomServices = service.slice(2);

  return (
    <>
      <section className="Service_page">
        <div className="container">
          <div className="Service_page_header_holder">
            <h5 className="Service_page_title">
              Solar Solutions for Every Need
            </h5>
            <p className="Service_page_subtitle">
              Smart, scalable solar solutions for residential, commercial, and
              institutional needs.
            </p>
          </div>

          <div className="services">
            <div className="row">
              {topServices.map((service, index) => (
                <div className="col-lg-6 col-md-6 mb-5">
                  <div
                    className="service_card"
                    key={index}
                    onClick={() => handleServiceClick(service.id)}
                  >
                    <div className="service_img_holder">
                      <img
                        src={IDS?.IMG_URL + service?.image}
                        alt={service.name}
                        className="top_image"
                      />
                    </div>
                    <div className="card_content">
                      <h3 className="service_title">{service.name}</h3>
                      <p className="service_desc">
                        {htmlToReactParser.parse(service.description)}
                      </p>
                      <p className="service_subtitle">
                        Best For:{" "}
                        {service?.ServiceBestFors?.map(
                          (item) => item?.BestFor?.name,
                        ).join(", ")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <Free_Consultation />
            <div className="row">
              {bottomServices.map((service, index) => (
                <div className="col-lg-6 col-md-6 mb-5">
                  <div
                    className="service_card"
                    key={index}
                    onClick={() => handleServiceClick(service.id)}
                  >
                    <div className="service_img_holder">
                      <img
                        src={IDS?.IMG_URL + service?.image}
                        alt={service.name}
                        className="top_image"
                      />
                    </div>
                    <div className="card_content">
                      <h3 className="service_title">{service.name}</h3>
                      <p className="service_desc">
                        {htmlToReactParser.parse(service.description)}
                      </p>
                      <p className="service_subtitle">
                        Best For:{" "}
                        {service?.ServiceBestFors?.map(
                          (item) => item?.BestFor?.name,
                        ).join(", ")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Service_page;
